import React from 'react';
import { useEffect } from 'react';
import {
  Link,
  Image,
  Heading,
  Flex,
  VStack,
  Center,
  Text,
  Box,
} from 'native-base';
import { useLocation } from 'react-router-dom';
import HeaderNav from '../HeaderNav/HeaderNav';
import { useAnalyticsHelper } from '../../hooks/useAnalyticsHelper';
import { useSegment } from '../../hooks/useSegment';
import { LOCAL_STORAGE_USER_INFO_KEY } from '../../constants/misc';
import {
  TRACKING_DOWNLOAD_APP_PAGE,
  TRACKING_PURCHASE_LOCAL_STORAGE_KEY,
} from '../OnboardingForm/constants';

const styles = {
  success: {
    marginTop: '8px',
    width: '100%',
    maxWidth: '600px',
    height: '100%',
    resizeMode: 'contain',
  },
  qr: {
    marginTop: '8px',
    width: '150px',
    maxWidth: '300px',
    height: '100%',
    resizeMode: 'contain',
  },
  downloadLink: {
    height: '48px',
  },
  storebtn: {
    width: '100%',
    minWidth: '110px',
    height: '44px',
    resizeMode: 'contain',
  },
  progressBar: {
    width: '100%',
    margin: '0',
  },
  width: 'auto',
};

function ThankYou() {
  const { updateTrackingLayer } = useAnalyticsHelper();
  const { page: pageView } = useSegment();
  const { state } = useLocation();

  const trackPurchaseComplete = !!localStorage.getItem(
    TRACKING_PURCHASE_LOCAL_STORAGE_KEY
  );

  const success = './../toast.png';
  const qrCode = './../onelinkto_nqnxxq-cp.png';
  const iosBtn =
    './../Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.png';
  const playStoreBtn = './../google-play-badge.png';
  const iosDownloadLink =
    'https://apps.apple.com/us/app/ayble-health-gi-gut-care/id1642365544';
  const androidDownloadLink =
    'https://play.google.com/store/apps/details?id=com.ayblehealth.app';

  useEffect(() => {
    pageView(TRACKING_DOWNLOAD_APP_PAGE);

    if (trackPurchaseComplete) {
      updateTrackingLayer(`Thank You`);
      localStorage.removeItem(TRACKING_PURCHASE_LOCAL_STORAGE_KEY);
      localStorage.removeItem(LOCAL_STORAGE_USER_INFO_KEY);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <HeaderNav page={1} hideBack />
      <Center>
        <VStack space={1} px={'3'} mb={10}>
          <Box
            mt={'4'}
            alignItems={'center'}
            minH={{ base: '200', md: '350', lg: '400' }}
          >
            <Image
              minH={{ base: '200', md: '350', lg: '400' }}
              alt="Ayble Food Finder"
              style={styles.success}
              source={{
                uri: success,
              }}
            />
          </Box>
          <Box mt={2} alignItems={'center'}>
            <Heading fontSize={'3xl'}>
              Hooray! You are on your way to better gut health.
            </Heading>
            {state?.eligible && (
              <Heading
                width={'80%'}
                lineHeight={'30'}
                mt={'2'}
                fontSize={'2xl'}
              >
                Your eligibility was verified and you
                can now start using Ayble!
              </Heading>
            )}

            <Heading mt={'2'} mb={'3'} fontSize={'2xl'}>
              Download the app and login.
            </Heading>
          </Box>
          <Box mt={2}>
            <Center>
              <Flex
                direction="column"
                alignItems={'center'}
                justify={'center'}
                w={'100%'}
                maxW={'670px'}
              >
                <Text textAlign={'center'}>
                  On your smartphone, download the Ayble Health app from the App
                  Store for iOS or the Google Play Store for Android devices.
                </Text>
                <Box
                  mt={'2'}
                  alignItems={'center'}
                  minH={{ base: '150', md: '150', lg: '150' }}
                >
                  <Image
                    minH={{ base: '170', md: '170', lg: '170' }}
                    alt="Ayble App"
                    style={styles.qr}
                    source={{
                      uri: qrCode,
                    }}
                  />
                </Box>
                <Flex
                  direction="row"
                  justify={'center'}
                  alignItems={'space-between'}
                  w={'100%'}
                  mt={2}
                >
                  <Link
                    w={'150'}
                    href={iosDownloadLink}
                    style={styles.downloadLink}
                  >
                    <Image
                      alt="Ayble App"
                      style={styles.storebtn}
                      source={{
                        uri: iosBtn,
                      }}
                    />
                  </Link>
                  <Link
                    w={'150'}
                    href={androidDownloadLink}
                    style={styles.downloadLink}
                  >
                    <Image
                      alt="Ayble App"
                      style={styles.storebtn}
                      source={{
                        uri: playStoreBtn,
                      }}
                    />
                  </Link>
                </Flex>
              </Flex>
            </Center>
          </Box>
        </VStack>
      </Center>
    </>
  );
}

export default ThankYou;
